import type { SearchEntry } from "./search";

let cached: SearchEntry[] | null = null;
let inflight: Promise<SearchEntry[]> | null = null;

export function getCachedSearchIndex(): SearchEntry[] | null {
  return cached;
}

export function prefetchSearchIndex(): Promise<SearchEntry[]> {
  if (cached) return Promise.resolve(cached);
  if (!inflight) {
    inflight = import("./search-index").then((module) => {
      cached = module.SEARCH_INDEX;
      return cached;
    }).finally(() => { inflight = null; });
  }
  return inflight;
}
